import React, { useState } from "react";
import { Dropdown, Button } from "antd";
import {
  PictureOutlined,
  VideoCameraOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

import "../../styles/bulletinAdmin/components/blockMenu.scss";

export default function BlockInsertMenu({
  onSelect,
  currentIndex,
  handleInsertBlock,
  icon,
}) {
  const [open, setOpen] = useState(false);

  const basicBlocks = [
    {
      key: "text",
      label: "T",
      title: "Text",
    },
  ];

  const mediaBlocks = [
    {
      key: "image",
      icon: <PictureOutlined />,
      title: "Image",
    },
    {
      key: "video",
      icon: <VideoCameraOutlined />,
      title: "Video",
    },
    {
      key: "file",
      icon: <FileTextOutlined />,
      title: "PDF File",
    },
  ];

  const handleSelect = (key) => {
    // Use the provided callback functions
    if (handleInsertBlock && currentIndex !== undefined) {
      handleInsertBlock(currentIndex, key);
    } else if (onSelect) {
      onSelect(key);
    }
    setOpen(false); // Close dropdown after selection
  };

  const dropdownContent = (
    <div className="block-insert-menu">
      <div className="section-title">Basic Blocks</div>
      <div className="block-list">
        {basicBlocks.map((item) => (
          <div
            key={item.key}
            className="block-item"
            onClick={() => handleSelect(item.key)}
          >
            <div className="block-icon basic">{item.label}</div>
            <div className="block-content">
              <div className="block-title">{item.title}</div>
              <div className="block-description">{item.description}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="section-title media">Media</div>
      <div className="block-list">
        {mediaBlocks.map((item) => (
          <div
            key={item.key}
            className="block-item"
            onClick={() => handleSelect(item.key)}
          >
            <div className="block-icon media">{item.icon}</div>
            <div className="block-content">
              <div className="block-title">{item.title}</div>
              <div className="block-description">{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <Dropdown
      trigger={["click"]}
      open={open}
      onOpenChange={(flag) => setOpen(flag)}
      placement="bottomLeft"
      dropdownRender={() => <div>{dropdownContent}</div>}
    >
      <Button type="text" icon={icon} size="small" />
    </Dropdown>
  );
}
